/** @jsx jsx */

import { jsx } from '@balance-web/core';
import { ArrowUpIcon } from '@balance-web/icon/icons/ArrowUpIcon';

export const SortIndicator = ({
  tone,
}: {
  tone: 'textPrimary' | 'textTertiary';
}) => {
  return (
    <span
      aria-hidden="true"
      css={{
        lineHeight: 0,
        paddingInline: 2,
        opacity: 0,
        transition: 'opacity 100ms linear, transform 150ms ease',

        '[aria-sort] &': {
          opacity: 1,
        },
        '[aria-sort="descending"] &': {
          transform: `rotate(180deg)`,
        },
      }}
    >
      <ArrowUpIcon color={tone} size="small" />
    </span>
  );
};
